import { createAction } from '@reduxjs/toolkit';

export const START_VIDEO_ACTION_TYPE = 'saga/startVideo';
export const startVideoAction = createAction(START_VIDEO_ACTION_TYPE);
